
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCurrent4 as ObiCurrent4Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-current-4.js';
 
 
 

 
 export const ObiCurrent4 = createComponent({
   react: React,
   tagName: 'obi-current-4',
   elementClass: ObiCurrent4Element,
   events: {
     
   }
  });
 
 